// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1bPud","header":"ReportDetails_header__2PxHf","title":"ReportDetails_title__2r1pn","left":"ReportDetails_left__3tfC1"};